import request from "../utils/request"

const getAuthorization=(params)=>{//绑定shopify店铺获取授权
   return request.post("/back/shopify/prebind",params)
}
const returnShopify=(params)=>{//shopify返回绑定店铺授权
    return request.get("/back/shopify/bind?"+params)
}
const getShopData=({p,name,status,size})=>{//获取shopify店铺列表数据
    return request.get(`/back/shopify/getshop?p=${p}&name=${name}&status=${status}&size=${size}`)
}
const syncOrder=()=>{//shopify订单同步
    return request.get("/back/shopify/syncorder")
}
const trouordertype=()=>{//获取shopify问题件数据
    return request.get("/back/shopify/trouordertype")
}
const getOrderData=(params)=>{//获取shopify订单列表数据
    return request.post(`/back/shopify/getorder`,params)
}
const getOrderDetailData=(id)=>{//获取shopify订单详情
    return request.get("/back/Shopify/OrderDetail?id="+id)
}
const editOrderDetail=(params)=>{//修改shopify客户收货地址
    return request.post("/back/shopify/updateorder",params)
}
const getUnifyShip=(params)=>{//订单页一键发货或者订单详情手动发货(共用接口)
    return request.post("/back/k5/add",params)
}
const backtracking=(params)=>{//shopify订单页回传运单
    return request.post("/back/shopify/backtracking",params)
}
const optshop=(params)=>{//shopify店铺操作店铺状态   opt => 0-禁用，1-启用，2-删除 , 3-修改
    return request.post(`/back/shopify/optshop`,params)
}
const addSku=(params)=>{//新增sku
    return request.post("/back/sku/add",params)
}
const getSkuData=({p,like,size,flow,status})=>{//获取sku列表数据
    return request.get(`/back/sku/get?p=${p}&like=${like}&flow=${flow}&status=${status}&size=${size}`)
}
const operationSku=(params)=>{//操作sku  (opt => 0-禁用，1-启用，2-删除，3-修改)
    return request.post(`/back/sku/opt`,params)
}
const optorder=({id,opt,trouid})=>{//shopify订单页订单操作  (opt =>  0-禁用、1-启用、2-删除、3-修改问题单)
    return request.get(`/back/shopify/optorder?id=${id}&opt=${opt}&trouid=${trouid}`)
}
const addPayNum=(params)=>{//收款账号添加
    return request.post("/back/paypalaccount/add",params)
}
const getPayAccount=({p})=>{//获取收款账号列表数据
    return request.get(`/back/paypalaccount/get?p=${p}`)
}
const editPayAccount=(params)=>{//收款账号操作
    return request.post("/back/paypalaccount/opt",params)
}
const getskuDetail=({id})=>{//获取sku详情数据
    return request.get(`/back/sku/detail?id=${id}`)
}
const getPayaccDetail=({id})=>{//获取收款账号详情数据
    return request.get(`/back/paypalaccount/detail?id=${id}`)
}
const getStoreDetail=({id})=>{//获取shopify店铺详情数据
    return request.get(`/back/shopify/shopdetail?id=${id}`)
}
const getStoreDrop=()=>{//绑定店铺新增收款账号
    return request.get(`/back/paypalaccount/drop`)
}
const getShopDrop=()=>{//获取shopify店铺下拉列表数据
    return request.get(`/back/shopify/shopdrop`)
}
const readd=({id,channelcode,sdkCode})=>{//订单详情页重新发货=>重发
    return request.get(`/back/k5/readd?id=${id}&channelcode=${channelcode}&sdkCode=${sdkCode}`)
}
const getK5=({id})=>{//订单详情页获取物流列表数据
    return request.get(`/back/k5/get?id=${id}`)
}
const orderflowdrop=()=>{//shopify订单页状态获取
    return request.get(`/back/shopify/orderflowdrop`)
}
const orderflow=({id})=>{//shopify订单页状态列表获取进度
    return request.get(`/back/shopify/orderflow?id=${id}`)
}
const ordercountry=()=>{//shopify订单页获取国家下拉列表数据
    return request.get(`/back/shopify/ordercountry`)
}
const k5Update=(params)=>{//订单详情页修改运单号
    return request.post("/back/k5/update",params)
}
const uploadPic=(formdata, config)=>{//上传图片
    return request.post("/upload/pic",formdata, config)
}
const shopcategoryAdd=(params)=>{//添加商品系列
    return request.post("/shopcategory/add",params)
}
const goodsAdd=(params)=>{//添加商品
    return request.post("/goods/add",params)
}
const getShopcategory=()=>{//新建商品获取商品系列
    return request.get(`/shopcategory/get`)
}
const getkeyvalue=({id})=>{//新建商品获取商品属性
    return request.get(`/skumap/getkeyvalue?cat=`+id)
}
const goodsBall=(params)=>{//商品列表数据
    return request.post("/goods/ball",params)
}
// ---------------------------------分割线-----------------------------------------
const getOrder=(params)=>{//获取订单页列表数据
    return request.post("/order/get",params)
}




export {
    getAuthorization,
    returnShopify,
    getShopData,
    syncOrder,
    trouordertype,
    getOrderData,
    getOrderDetailData,
    editOrderDetail,
    getUnifyShip,
    backtracking,
    optshop,
    addSku,
    getSkuData,
    operationSku,
    optorder,
    addPayNum,
    getPayAccount,
    editPayAccount,
    getskuDetail,
    getPayaccDetail,
    getStoreDetail,
    getStoreDrop,
    getShopDrop,
    readd,
    getK5,
    orderflowdrop,
    orderflow,
    ordercountry,
    k5Update,
    uploadPic,
    shopcategoryAdd,
    goodsAdd,
    getShopcategory,
    getkeyvalue,
    goodsBall,
    getOrder
}